import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import JisEmptyList from "../components/controls/emptylist";
import Pagenated from "../components/pagenated";
import CaseDetails from "../components/core/caseDetails";
import JisDialog from "../components/dialog";
import JisYesNo from "../components/controls/jisYesNo";
import JisDialogForm from "../components/formdialog";
import DeadlineBadge from "../components/controls/deadlinebadge";
import JisTabButton from "../components/controls/jisTabButton";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";
import wordicon from "../assets/ms_word.png";
import excelicon from "../assets/ms_excel.png";
import pdficon from "../assets/pdf.png";
import JisCheckbox from "../components/controls/jisCheckbox";
import PdfViewer from "../components/controls/pdfviewer";
import { Autocomplete, TextField } from "@mui/material";
import { CommentDropdown } from "../components/clearOptionsModal";
import useComments from "../hooks/useComment";

function Screeners() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert ,holidays} =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState({});
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [tab, setTab] = useState("pending");
  const [isAccept, setIsAccept] = useState(null);
  const [isRework, setIsRework] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [missingDocs, setMissingDocs] = useState([]);
  const [showOmittedDocs, setShowOmittedDocs] = useState(false);
  const [reworkGazettes, setReworkGazettes] = useState([]);
  const [gazetteSearch, setGazetteSearch] = useState("");
  const [isDocPreview, setIsDocPreview] = useState(false);
  const [previewDocUrl, setPreviewDocUrl] = useState("");
  const { comments: predefinedComments } = useComments(token);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null && Object.keys(search).length > 0) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
      onLoad();
    }
  }, [pageIndex, pageSize, tab, search]);

  console.log({ cases });

  const onSearch = async (sear) => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/screeners/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      // setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    } finally {
      setLoading(false);
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/screeners/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            caseTitle: "",
            caseNumber: "",
            fromDate: "",
            toDate: "",
            filingtype: "all",
            caseprocess: "all",
            caseTypeId: "",
            caseCategoryId: "",
          }),
        },
      );
      const data = await resp.json();
      // setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onAdrLitigation = (fee, ind) => {
    //can load the option for filing type and display
    setActive(fee);
    setIndex(ind);
    setOpenOption(true);
    setOption({ caseId: fee.caseId, divisionId: fee.divisionId });
    setSuitnumber("");
    setIsAccept(null);
    setIsRework(null);
    setDocuments([]);
    setMissingDocs([]);
    setShowOmittedDocs(false);
  };

  const onSave = async (e) => {
    e.preventDefault();
    if (isLiti == null) {
      setErr("Please select the ADR/Litigation option");
      return;
    }
    if (isLiti === false && isAccept === null) {
      setErr("Please select Accept or Reject");
      return;
    }
    if (isLiti === false && isAccept === true && suitNumber == "") {
      setErr("Please generate Suit Number to Preview first");
      return;
    }
    if (isLiti === false && isAccept === false && isRework === null) {
      setErr("Please select Rework or Outright Reject");
      return;
    }
    setErr("");
    var approve = {
      ...option,
      isLitigation: isLiti,
      suitNumber: suitNumber,
      source: "screener",
    };
    if (isLiti === false && isAccept === false) {
      if (isRework === true) {
        const rw = documents
          .filter((d) => d.isLegal || d.isCfo)
          .map((d) => ({
            docid: d.id,
            isLegal: d.isLegal || false,
            isCfo: d.isCfo || false,
            comment: d.comment || "",
            docTitle: d.title || "",
          }));
        approve.reworks = rw;
        if (showOmittedDocs && missingDocs.length > 0) {
          approve.MissingGazetteIds = missingDocs.map((d) => ({
            id: d.id,
            title: d.title,
            itemType: d.itemType,
            perItem: d.fee,
            qty: 1,
          }));
        }
      }
    }

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-litigation-approval`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        const ft = cases.filter((_, i) => i !== index);
        setCases(ft);
        if (isLiti == false) {
          setAlert({
            open: true,
            title: "ADR Option",
            subtitle: "Case moved to ADR successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "ADR Option",
            subtitle: "Litigation option set successfully",
          });
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onGenerateNumber = async (e) => {
    e.preventDefault();
    if (isLiti == null) {
      setErr("Please select the ADR/Litigation option");
      return;
    }
    if (
      option.divisionId == "" ||
      option.subCategoryId == "" ||
      option.caseCategoryId == ""
    ) {
      setErr(
        "Please select from the options of Classification and sub Classification",
      );
      return;
    }
    setErr("");
    var approve = { ...option, isLitigation: isLiti, source: "screener" };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/generate-suit-number`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      // setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setSuitnumber(data.suit);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    } finally {
      setLoading(false);
    }
  };
  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (isRework == true) {
      setLoading(true);
      Promise.all([onLoadDocuments(), onLoadGazette()]).finally(() =>
        setLoading(false),
      );
    }
  }, [isRework]);

  const onLoadDocuments = async () => {
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${active?.caseId}/documents`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      if (data.code == 0) {
        setDocuments(data.documents);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onLoadGazette = async () => {
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-for-rework/${active?.caseFilingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      if (data.code === 0) {
        setReworkGazettes(data.gazettes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const rework_handleChange = (id, field, value) => {
    setDocuments((prev) =>
      prev.map((d) => (d.id === id ? { ...d, [field]: value } : d)),
    );
  };

  const onAddMissingDoc = (gazid) => {
    const gazExist = missingDocs.find((d) => d.id == gazid);
    if (!gazExist) {
      const newGaz = reworkGazettes.find((d) => d.id == gazid);
      if (!newGaz) return;
      setMissingDocs((prev) => [...prev, { ...newGaz }]);
    }
  };

  const onPreviewDocModal = (docs) => {
    setIsDocPreview(true);
    var finalpath = "";
    if (docs.documentLocation != null) {
      finalpath = Constants.RelativeFiletoRelative(
        Constants.getDocumentPath(docs)
      );
    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewDocUrl(finalpath);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };
  return (
    <div>
      {/* <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
      />

      <div className="tab_body">
        {" "}
        <div className="exportdiv">
          <img
            src={wordicon}
            // onClick={() => onExport("word")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={excelicon}
            // onClick={() => onExport("excel")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={pdficon}
            // onClick={() => onExport("pdf")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Pending Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("pending")}
          />

          {/*    <JisTabButton isActive={tab=='reject'}   title="Rejected Cases" 
       isRoleBased={false} onClick={()=> setTab('reject')}/> */}

          <JisTabButton
            isActive={tab == "rework"}
            title="Rework Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("rework")}
          />

          <JisTabButton
            isActive={tab == "processed"}
            title="Processed Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("processed")}
          />
        </div>
        <div className="tab_view"></div>
      </div>
      {cases?.length === 0 && cases?.length == 0 && !loading && (
        <JisEmptyList />
      )}
      {cases?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>Screener ADR Cases</span>
          </div>
          <div className="table-wrapper">
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Suit Number</th>
                  <th className="col-title">Case Title</th>
                  <th className="col-medium">Date Initiated</th>
                  <th className="col-medium">Filing Type</th>
                  {/* <th className="col-medium">Classification</th>
                  <th className="col-medium">Status Level</th>
                  <th>SLA</th> */}
                  <th className="col-title">Details</th>

                  {/* {tab != "processed" && <th>ADR/Litigation</th>} */}
                  {tab != "processed" && (
                    <>
                      <th>Re-route to Litigation</th>
                      <th className="col-action">Action</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {cases?.map((opt, index) => {
                  const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                  return (
                    <tr key={opt.caseId}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.referenceNumber || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>{" "}
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      {/* <td>
                        {" "}
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId
                        )?.description || "N/A"}
                      </td>
                      <td>
                        {" "}
                        <DeadlineBadge dateString={opt.slaExpire} />
                      </td> */}
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onContinue(opt, index)}
                        >
                          View
                        </JisButton>
                      </td>
                      {/* {tab != "processed" && (
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onAdrLitigation(opt, index)}
                          >
                            ADR/Litigation
                          </JisButton>
                        </td>
                      )} */}
                      {tab != "processed" && (
                        <>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => {
                                setIsLitiation(true);
                                onAdrLitigation(opt, index);
                              }}
                            >
                              Re-route
                            </JisButton>
                          </td>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => {
                                setIsLitiation(false);
                                onAdrLitigation(opt, index);
                              }}
                            >
                              Process
                            </JisButton>
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {cases?.length > 0 && (
            <Pagenated
              onChangePageSize={(k) => setPageSize(k)}
              size={pageSize}
              total={count}
              maxPage={20}
              onPick={onPagePick}
            />
          )}
        </div>
      )}
      <BackLoader open={loading} />

      {openOption && isLiti === true && (
        <JisDialogForm
          title="Re-route Case to litigation"
          onClose={() => setOpenOption(false)}
        >
          <form className="litigation_form_wrapper" onSubmit={onSave}>
            <div>
              <p className="litigation_form_header">
                <span>Ref number:</span> {active?.referenceNumber}
              </p>
              <div className="input-group">
                <label>Comment</label>
                <div className="">
                  <textarea
                    style={{
                      minHeight: 120,
                      height: 120,
                      resize: "none",
                      borderRadius: 8,
                      padding: 14,
                      border: "1px solid #C8CACE",
                      width: "100%",
                      // color: "#ADB0B6",
                      backgroundColor: "#ffffff",
                    }}
                    placeholder="Add Comment"
                    name="comment"
                    required={true}
                    value={option.comment}
                    onChange={onOptionChange}
                  />
                </div>
              </div>

              <div className="re-route_btn_wrapper">
                <button
                  type="button"
                  className=""
                  onClick={() => setOpenOption(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="">
                  Save{" "}
                </button>
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}
      {openOption && isLiti === false && (
        <div className="litigation_dialog_wrapper screener_litigation_dialog_wrapper">
          <div className="litigation_dialog_container">
            <div className="dialog_header">
              <p>Process Case</p>
              <button className="" onClick={() => setOpenOption(false)}>
                <DynamicIcon size={24} color="white" iname="circle-x" />
              </button>
            </div>
            <form onSubmit={onSave} className="dialog_content">
              <div style={{ marginTop: "24px" }}>
                {suitNumber !== "" ? (
                  <p className="litigation_form_header">
                    <span>suit number:</span> {suitNumber}
                  </p>
                ) : (
                  <p className="litigation_form_header">
                    <span>Ref number:</span> {active?.referenceNumber}
                  </p>
                )}
              </div>

              <JisYesNo
                label="Accept or Reject this Case"
                value={isAccept}
                yes="Accept"
                no="Reject"
                onChange={(e) => setIsAccept(e)}
                applyButtonStyle={true}
              />

              {isAccept === true && (
                <div>
                  <div className="select-group">
                    <label>Division</label>
                    <select
                      name="divisionId"
                      value={option.divisionId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Classification:</label>
                    <select
                      name="caseCategoryId"
                      value={option.caseCategoryId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select Classification </option>
                      <option value="0">Alternative Dispute Resolution</option>
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Sub-Classification:</label>
                    <select
                      name="subCategoryId"
                      value={option.subCategoryId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select Sub-Classification </option>
                      <option value="0">ADR</option>
                    </select>
                  </div>
                </div>
              )}

              {isAccept === false && (
                <div>
                  <JisYesNo
                    label="The mode either Rework or Reject"
                    value={isRework}
                    yes="Re-work Document(s)"
                    no="Outright Case Reject"
                    onChange={(e) => setIsRework(e)}
                    applyButtonStyle={true}
                  />
                  {isRework === true && (
                    <div>
                      <p>The documents</p>
                      <div className="table">
                        <div className="section-cases">
                          <span>Case Documents</span>
                        </div>
                        <table className="case-table">
                          <thead>
                            <tr>
                              <th className="col-title">Title</th>
                              <th>Filed On</th>
                              <th className="col-action">Preview</th>
                              <th className="col-action">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documents?.map((doc, index) => (
                              <tr key={doc.id || index}>
                                <td>{doc.title || "N/A"}</td>
                                <td>
                                  {Constants.momentDate(doc.createdOn).format(
                                    "DD MMM, YYYY",
                                  ) || "N/A"}
                                </td>
                                <td>
                                  <JisButton
                                    variant="plain"
                                    onClick={() => onPreviewDocModal(doc)}
                                  >
                                    Preview
                                  </JisButton>
                                </td>
                                <td>
                                  <div>
                                    <div style={{ display: "flex" }}>
                                      <JisCheckbox
                                        label="For Legal Counsel"
                                        value={doc.isLegal}
                                        onChange={(e) =>
                                          rework_handleChange(
                                            doc.id,
                                            "isLegal",
                                            e,
                                          )
                                        }
                                      />
                                      <JisCheckbox
                                        label="For CFO"
                                        value={doc.isCfo}
                                        onChange={(e) =>
                                          rework_handleChange(
                                            doc.id,
                                            "isCfo",
                                            e,
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="input-group">
                                      <div className="input-wrapper">
                                        <input
                                          placeholder="Comment"
                                          value={doc.comment}
                                          onChange={(e) =>
                                            rework_handleChange(
                                              doc.id,
                                              "comment",
                                              e.target.value,
                                            )
                                          }
                                          required={doc.isLegal || doc.isCfo}
                                          disabled={!(doc.isLegal || doc.isCfo)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div style={{ marginTop: 16, marginBottom: 16 }}>
                        <JisCheckbox
                          label="Request Filing of Omitted Documents"
                          value={showOmittedDocs}
                          onChange={(e) => setShowOmittedDocs(e)}
                        />
                      </div>

                      {showOmittedDocs && (
                        <>
                          <div className="select-group">
                            <label>Select Gazette Items:</label>
                            <Autocomplete
                              options={reworkGazettes || []}
                              getOptionLabel={(option) => option.title || ""}
                              inputValue={gazetteSearch}
                              onInputChange={(_, newInputValue) =>
                                setGazetteSearch(newInputValue)
                              }
                              filterOptions={(options) =>
                                options.filter((option) =>
                                  (option.title || "")
                                    .toLowerCase()
                                    .includes(gazetteSearch.toLowerCase()),
                                )
                              }
                              onChange={(_event, newValue) => {
                                if (newValue) {
                                  onAddMissingDoc(newValue.id);
                                  setGazetteSearch("");
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search gazette items..."
                                  size="small"
                                   required={missingDocs.length>0?false:showOmittedDocs}
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              noOptionsText="No gazette items found"
                              blurOnSelect
                              size="small"
                            />
                          </div>
                          <div>Added Document ({missingDocs.length})</div>
                          <div style={{ display: "flex" }}>
                            {missingDocs?.map((doc) => (
                              <div
                                key={doc.id}
                                className="selected"
                                style={{ display: "flex", gap: 15 }}
                              >
                                <div style={{ flex: 1 }}>{doc.title}</div>
                                <div>
                                  <DynamicIcon
                                    iname="square-x"
                                    size={21}
                                    onClick={() =>
                                      setMissingDocs((prev) =>
                                        prev.filter((d) => d.id !== doc.id),
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="input-group">
                <CommentDropdown
                  placeholder="Comment"
                  name="comment"
                  required={true}
                  reasonPlaceHolder="Reason (select all that apply)"
                  value={option.comment || ""}
                  predefinedComments={predefinedComments}
                  onChange={(e) =>
                    onOptionChange({
                      target: { name: "comment", value: e.target.value },
                    })
                  }
                />
              </div>
              {err != "" && <div className="error">{err}</div>}

              {isAccept === true &&
                (suitNumber != "" ? (
                  <div style={{ marginBottom: "16px", marginTop: "36px" }}>
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#5ca9fb",
                        color: "#ffffff",
                        padding: "8px 16px",
                        borderRadius: 8,
                        border: "none",
                        cursor: "pointer",
                        fontSize: 16,
                        width: "100%",
                        height: 64,
                      }}
                    >
                      Continue
                    </button>
                  </div>
                ) : (
                  <div style={{ marginBottom: "16px", marginTop: "36px" }}>
                    <button
                      type="button"
                      onClick={onGenerateNumber}
                      style={{
                        backgroundColor: "#5ca9fb",
                        color: "#ffffff",
                        padding: "8px 16px",
                        borderRadius: 8,
                        border: "none",
                        cursor: "pointer",
                        fontSize: 16,
                        width: "100%",
                        height: 64,
                      }}
                    >
                      Generate Suit Number
                    </button>
                  </div>
                ))}

              {isAccept === false && (
                <div style={{ marginBottom: "16px", marginTop: "36px" }}>
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#5ca9fb",
                      color: "#ffffff",
                      padding: "8px 16px",
                      borderRadius: 8,
                      border: "none",
                      cursor: "pointer",
                      fontSize: 16,
                      width: "100%",
                      height: 64,
                    }}
                  >
                    Save
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      )}

      {isDocPreview && previewDocUrl != "" && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsDocPreview(false)}
        >
          <div style={{ height: "90vh" }}>
            <PdfViewer pdfUrl={previewDocUrl} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default Screeners;
